<template>
  <mp-box as="nav" border-bottom-color="gray.100" border-bottom-width="1px" border-style="solid" px="6" py="1.5" bg="white">
    <mp-flex flex-direction="row" justify="space-between" align="center">
      <mp-flex gap="6">
        <!-- Logo -->
        <mp-box as="a" to="/" :display="['none', 'block']">
          <img :src="$logo" width="118" height="34" />
        </mp-box>
        <mp-box as="a" to="/" :display="['block', 'none']">
          <mp-icon name="talenta-brand" size="lg" />
        </mp-box>
        <template v-if="!logoutOnly">
          <mp-divider orientation="vertical" margin-x="0" margin-y="8px!important" :display="['none', 'block']" />

          <!-- Select Apps -->
          <mp-popover :display="['none', 'block']" use-portal close-on-select>
            <mp-popover-trigger>
              <mp-button
                data-qa="navbar-user-action-select-apps"
                variant="ghost"
                color="gray.600"
                right-icon="caret-down"
                :display="['none', 'block']"
              >
                Performance Management
              </mp-button>
            </mp-popover-trigger>
            <mp-popover-content max-width="64" bg="white" rounded="md" shadow="lg" border-width="1px" border-color="gray.400">
              <mp-popover-list>
                <mp-box width="full" padding-x="3" padding-y="2">
                  <mp-text color="gray.600" font-size="sm" text-align="left">
                    SELECT APPS
                  </mp-text>
                </mp-box>
                <mp-popover-list-item v-if="!isKakiTangan" as="a" :href="$coreBaseURL" target="_blank" data-qa="navbar-user-action-select-core"
                  >HRIS (Main product)</mp-popover-list-item
                >
                <mp-popover-list-item v-if="!isKakiTangan" as="a" :href="$insight" target="_blank" data-qa="navbar-user-action-select-inights"
                  >Insights</mp-popover-list-item
                >
                <mp-popover-list-item font-weight="bold">
                  Performance management
                  <mp-icon name="check" size="sm" margin-right="2" />
                </mp-popover-list-item>
              </mp-popover-list>
            </mp-popover-content>
          </mp-popover>
        </template>
      </mp-flex>

      <mp-box>
        <mp-flex justify="space-between" align="center">
          <mp-stack v-if="!logoutOnly" is-inline spacing="5">
            <mp-box>
              <!-- Dropdown create -->
              <mp-popover use-portal close-on-select>
                <mp-popover-trigger>
                  <mp-box>
                    <mp-tooltip position="bottom" label="Quick action" use-portal>
                      <mp-button-icon name="add" size="md" data-qa="navbar-user-action-quick-actions" />
                    </mp-tooltip>
                  </mp-box>
                </mp-popover-trigger>
                <mp-popover-content max-width="56" background-color="overlayFill" box-shadow="lg" border-radius="md">
                  <mp-popover-list>
                    <mp-box width="full" padding-x="3" padding-y="2">
                      <mp-text color="gray.100" text-align="left">
                        CREATE
                      </mp-text>
                    </mp-box>
                    <mp-popover-list-item
                      v-if="isEligibleCreateGoal"
                      background-color="transparent"
                      color="white"
                      :_hover="{
                        color: 'white',
                        backgroundColor: 'blue.400',
                      }"
                      data-qa="navbar-user-action-quick-goals"
                      @click="$store.dispatch('goals/onClickCreateNewGoal')"
                      >New goals
                    </mp-popover-list-item>
                    <mp-popover-list-item
                      v-if="isSuperAdmin || hasAccess('review-cycle.add')"
                      background-color="transparent"
                      color="white"
                      :_hover="{
                        color: 'white',
                        backgroundColor: 'blue.400',
                      }"
                      data-qa="navbar-user-action-quick-cycle"
                    >
                      <button-create-cycle :is-disabled="$route.name === 'review_cycle_create'">
                        New review cycle
                      </button-create-cycle>
                    </mp-popover-list-item>
                  </mp-popover-list>
                </mp-popover-content>
              </mp-popover>
            </mp-box>

            <mp-box m="0"> 
              <!-- Download notification -->
              <download-notification ref="downloadNotification" />
            </mp-box>

            <mp-box v-if="!isKakiTangan" m="0">
              <!-- Quick links -->
              <mp-button-icon
                v-mp-tooltip="{
                  label: 'Switch app',
                  position: 'bottom',
                }"
                name="shortcuts"
                size="md"
                data-qa="navbar-quick-link"
                @click="isSwitchAppOpen = true"
              />
            </mp-box>
          </mp-stack>

          <!-- Dropdown actions -->
          <mp-popover id="popover-profile-menu" placement="bottom-start">
            <mp-popover-trigger data-qa="navbar-user-action">
              <mp-flex
                align="center"
                ml="5"
                px="2"
                py="1"
                rounded="md"
                transition="all 0.2s ease-in-out"
                :_hover="{
                  bg: 'background',
                  cursor: 'pointer',
                }"
              >
                <mp-avatar :name="fullName" :src="avatarUrl" size="md" />
                <mp-flex v-if="!logoutOnly" flex-direction="column" ml="2">
                  <mp-text font-weight="semibold" line-height="md">{{ fullName }}</mp-text>
                  <mp-text v-if="consultant" font-size="sm" color="gray.600">{{ consultant.name }}</mp-text>
                </mp-flex>
              </mp-flex>
            </mp-popover-trigger>
            <mp-popover-content bg="white" box-shadow="lg" rounded="md" border="1px solid" border-color="gray.400" max-width="65" z-index="99">
              <!-- Parent section -->
              <mp-box :display="parentToggle ? 'block' : 'none'">
                <mp-popover-header v-if="!logoutOnly" border-top-radius="md" py="4" bg="background" border-bottom="1px" border-color="gray.100">
                  <mp-box text-align="center" w="100%">
                    <mp-avatar :name="fullName" :src="avatarUrl" size="lg" mb="2" />
                    <mp-text font-weight="semibold">{{ fullName }}</mp-text>
                    <mp-text v-if="consultant" font-size="sm" color="gray.600">{{ consultant.name }}</mp-text>
                  </mp-box>
                </mp-popover-header>
                <mp-popover-list>
                  <mp-popover-list-item
                    as="a"
                    href="https://help-center.talenta.co/hc/id/articles/11427496661785-Sekilas-Tentang-Talenta-Performance"
                    target="_blank"
                    data-qa="navbar-user-action-help"
                    >Help & Support</mp-popover-list-item
                  >

                  <template v-if="!logoutOnly">
                    <mp-popover-list-item v-if="isAbleSelectCompany" is-arrow data-qa="navbar-user-action-company" @click="onClickCompanyList(true)"
                      >Company list</mp-popover-list-item
                    >
                    <mp-divider v-if="isAbleSelectCompany || !isKakiTangan" w="100%" my="8px!important" />
                    <mp-popover-list-item v-if="!isKakiTangan" as="a" :href="$sso.url" target="_blank" data-qa="navbar-user-action-mekari-account">
                      Go to Mekari Account
                      <mp-icon name="newtab" size="sm" ml="auto" />
                    </mp-popover-list-item>
                  </template>

                  <mp-popover-list-item data-qa="navbar-user-action-logout" @click="logout">Sign out</mp-popover-list-item>
                </mp-popover-list>
                <mp-box pt="2" pb="3">
                  <mp-flex>
                    <mp-box color="gray.600" font-size="xs" ml="3" as="a" href="https://mekari.com/kebijakan-privasi/" target="_blank"
                      >Privacy</mp-box
                    >
                    <mp-box color="gray.600" font-size="xs" ml="3" as="a" href="https://mekari.com/persyaratan-layanan/" target="_blank"
                      >Term of use</mp-box
                    >
                    <mp-box color="gray.600" font-size="xs" ml="3" as="a" href="https://mekari.com/tentang-mekari-account/" target="_blank"
                      >About Mekari Account</mp-box
                    >
                  </mp-flex>
                  <mp-box color="gray.600" font-size="xs" ml="3">Mekari © {{ year }}</mp-box>
                </mp-box>
              </mp-box>

              <!-- Company list section -->
              <mp-box :display="isShowCompanyList ? 'block' : 'none'">
                <mp-popover-header border-top-radius="md" border-bottom="1px" border-color="gray.100">
                  <mp-button-icon
                    size="sm"
                    name="arrows-left"
                    margin-right="2"
                    padding="0"
                    :is-hoverable="false"
                    @click="onClickCompanyList(false)"
                  />
                  <mp-text font-weight="semibold">Company list</mp-text>
                </mp-popover-header>
                <mp-popover-list v-if="isAbleSelectCompany" border-bottom-radius="md" max-h="300px" overflow-y="auto">
                  <mp-popover-list-item
                    v-for="company in companies"
                    :key="company.company_id"
                    :is-disabled="isLoadingCompany"
                    @click="changeCompany(company)"
                  >
                    {{ company.name }}
                    <mp-icon v-if="company.company_id === cid" name="check" size="sm" margin-right="2" />
                  </mp-popover-list-item>
                </mp-popover-list>
              </mp-box>
            </mp-popover-content>
          </mp-popover>
        </mp-flex>
      </mp-box>
    </mp-flex>

    <quick-links v-if="!logoutOnly" :name="userData.first_name" :is-switch-app-open="isSwitchAppOpen" :on-switch-app-toggle="onSwitchAppToggle" />
  </mp-box>
</template>
<script>
import { MpAvatar, MpStack, MpTooltip } from '@mekari/pixel';
import { mapGetters } from 'vuex';
import QuickLinks from '@/components/layouts/QuickLinks';
import DownloadNotification from '@/components/layouts/DownloadNotification';
import ButtonCreateCycle from '@/views/reviews/cycle/components/ButtonCreateCycle';
import { alertMixin, generalMixin } from '@/mixins/general';
import roleMixin from '@/mixins/role';

export default {
  name: 'PixelNavbar',
  components: {
    MpAvatar,
    MpStack,
    MpTooltip,
    QuickLinks,
    DownloadNotification,
    ButtonCreateCycle,
  },
  mixins: [alertMixin, generalMixin, roleMixin],
  props: {
    logoutOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSwitchAppOpen: false,
      parentToggle: true,
      isShowCompanyList: false,
      isLoadingCompany: false,
    };
  },
  computed: {
    ...mapGetters({
      isEligibleCreateGoal: 'goals/isEligibleCreateGoal',
    }),
    fullName() {
      return this.userData?.last_name ? `${this.userData?.first_name} ${this.userData?.last_name}` : this.userData?.first_name ?? '';
    },
    avatarUrl() {
      return this.userData?.avatar ? this.$imgPath + this.userData?.avatar : '';
    },
    isAbleSelectCompany() {
      return Boolean(this.companies?.length) || false;
    },
    companies() {
      return this.$store.getters.companiesData;
    },
    year() {
      return new Date().getFullYear();
    },
    isKakiTangan() {
      return this.$store.state.isKakiTangan;
    },
  },
  mounted() {
    this.getGoalSettings();
  },
  methods: {
    onSwitchAppToggle() {
      this.isSwitchAppOpen = !this.isSwitchAppOpen;
    },
    onClickCompanyList(value) {
      this.parentToggle = !value;
      this.isShowCompanyList = value;
    },
    async changeCompany(company) {
      try {
        this.isLoadingCompany = true;
        const url = `${this.$nonCoreEndPoint}/shared/consultant/choose-company/${company.company_id}`;
        const res = await this.$axios.post(url);

        this.$cookies.set('isa-consultant', res.data.isa);
        this.$cookies.set('consultant', company);
        this.$cookies.remove('can-access-succession-plan');

        this.getPendingTask(); // To update total pending action in sidebar every-time company changed
      } catch (e) {
        this.alertToast('Failed to change company', 'danger');
      } finally {
        this.isLoadingCompany = false;
      }
    },
    async getPendingTask() {
      try {
        await this.$store.dispatch('review/getTotalPendingTask');
      } catch (e) {
        console.log(e);
      } finally {
        window.location.reload();
      }
    },
    async getGoalSettings() {
      try {
        await this.$store.dispatch('goals/getGoalSettings');
      } catch (err) {
        this.alertToast(err.message, 'danger');
      }
    },
  },
};
</script>
